import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Droppable } from 'react-beautiful-dnd'
import Card from '../Card/Card'
import './list.css'

const List = ({ data, listIndex, openTask, setSlackShareData }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <Droppable droppableId={`list:${listIndex}`} type={'LIST'}>
      {({ innerRef, droppableProps, placeholder }) => (
        <div {...droppableProps} ref={innerRef} className='cards'>
          <div className='list-header'>
            <h2>
              {data.status === 'OPEN'
                ? '🎯  To do'
                : data.status === 'IN_PROGRESS'
                  ? '🚀  In progress'
                  : '💪  Done'}
              <span>{data?.docs?.length !== 0 ? data.docs.length : ''}</span>
            </h2>
            <button
              onClick={() =>
                navigate(
                  `/tasks/?tag=${
                    searchParams.get('tag') &&
                    searchParams.get('tag') !== 'null'
                      ? searchParams.get('tag')
                      : ''
                  }&task=&card=${data.status}`
                )
              }
            >
              +
            </button>
          </div>
          <span className='overdue'>
            {data?.overdue &&
              data.status !== 'DONE' &&
              `${data.overdue}% overdue`}
          </span>
          <div className='card-list'>
            {data?.docs?.map((item, cardIndex) => (
              <Card
                setSlackShareData={setSlackShareData}
                openTask={openTask}
                data={item}
                key={`card:${item._id}`}
                cardIndex={cardIndex}
              />
            ))}
          </div>
          {placeholder}
        </div>
      )}
    </Droppable>
  )
}

export default List
